/**
 * DevExtreme (esm/ui/button.js)
 * Version: 23.2.8
 * Build date: Fri Aug 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import Widget from "../renovation/ui/button.j";
export default Widget;
